import { useHistory } from 'react-router-dom';
import Icon from '@ui/components/Icon/Icon';
import Text from '@ui/components/Text/Text';

import './CardBenefitInformation.scss';
import { VERYBUSY_LANDING_URL } from 'src/config/urls';
import useFetchCurrentUserQuery from 'src/new_arch/modules/authentication/queries/useFetchCurrentUserQuery';
import useLogout from 'src/new_arch/modules/authentication/queries/useLogout';
import { Button } from '@mantine/core';

const CardBenefitInformation = () => {
	const { data: currentUser } = useFetchCurrentUserQuery();
	const { logout } = useLogout();
	const history = useHistory();
	const onSignUpClicked = ( event? : React.MouseEvent ) => {
		event?.preventDefault();
		logout();
		history.replace( '/signup', {
			isGuestSignup: true,
			email: currentUser?.email
		} );
	}
	const onLearnMoreClicked = () => {
		window.open( VERYBUSY_LANDING_URL, '_blank', 'noopener,noreferrer' );
	};

	return (
		<div className="CardBenefitInformation">
			<h1 className="card-title">
				Get the most out of verybusy.
			</h1>
			<div className="card-body">
				<div className="subtitle-section">
					<Text variant="body-bold" color="#1C91FF" style={{ marginBottom: 12, fontSize: 16 }}>
						Benefits of a VB account:
					</Text>
				</div>
				<div className="icons-section">
					<div>
						<Icon icon="link" size={18} color="#1C91FF" />
						<Text variant="body">
							Easy access, now saved. No need to search for links again.
						</Text>
					</div>
					<div>
						<Icon icon="notifications-outlined" size={18} color="#1C91FF" />
						<Text>
							Personalized notifications.
						</Text>
					</div>
					<div>
						<Icon icon="assignment-outlined" size={18} color="#1C91FF" />
						<Text>
							Easily view and oversee all projects.
						</Text>
					</div>
					<div>
						<Icon icon="how-to-reg-outlined" size={18} color="#1C91FF" />
						<Text>
							Manage your profile settings.
						</Text>
					</div>
				</div>
			</div>
			<div className="card-actions">
				<Button variant="white" color="gray.9" size="xs" onClick={onLearnMoreClicked}>
					Learn More
				</Button>
				<Button size="xs" onClick={onSignUpClicked}>
					Create Free Account
				</Button>
			</div>
		</div>
	);
};

export default CardBenefitInformation;
